<footer class="bgPrimary fixed-bottom">
  <div
    class="container d-flex justify-content-between align-items-center flex-md-row flex-column"
  >
    <div></div>
    <div class="d-flex align-items-center justify-content-center">
      <p class="mb-0 font14">© Institute For Training in Ministry {{ year }}</p>
    </div>
    <div class="dropdown d-flex">
      <div
        id="google_translate_element"
        class="g-translate position-static ms-3 d-flex justify-content-center align-items-center"
      >
        <i class="fas fa-globe"></i>
      </div>
      <div
        class="dropdown-menu dropdown-menu-end"
        aria-labelledby="dropdownMenuClickableInside"
      ></div>
    </div>
  </div>
</footer>

<button
  type="button"
  [hidden]="true"
  class="btn btn-primary"
  id="bt1"
  data-toggle="modal"
  data-target="#exampleModalLong"
>
  Launch demo modal
</button>
<!-- Modal -->
<div
  class="modal fade"
  id="exampleModalLong"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLongTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header border-0 py-0 pt-0">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>
          Please enter your name and email address and we will get in touch with
          you.
        </p>
        <form [formGroup]="formGroup" *ngIf="formGroup">
          <div class="form-group">
            <label for="" class="font18">Your Name (required)</label>
            <input
              type="text"
              class="form-control"
              name="email"
              placeholder="Your Name"
              formControlName="name"
              placeholder="First Name"
              [class.is-invalid]="isControlInvalid('name')"
              [class.is-valid]="isControlValid('name')"
              autocomplete="off"
            />
            <h5
              class="invalid-feedback"
              *ngIf="controlHasError('required', 'name')"
            >
              This field is required
            </h5>
            <h5
              class="invalid-feedback"
              *ngIf="controlHasError('maxlength', 'name')"
            >
              Please enter a value shorter or equal to 50 characters.
            </h5>
          </div>
          <div class="form-group">
            <label for="" class="font18">Your Email (required)</label>
            <input
              type="email"
              class="form-control"
              id=""
              placeholder="Your Email"
              formControlName="email"
              placeholder="Email"
              [class.is-invalid]="isControlInvalid('email')"
              [class.is-valid]="isControlValid('email')"
              autocomplete="off"
            />
            <h5
              class="invalid-feedback"
              *ngIf="controlHasError('required', 'email')"
            >
              This field is required
            </h5>
            <h5
              class="invalid-feedback"
              *ngIf="controlHasError('pattern', 'email')"
            >
              Please enter a valid email
            </h5>
          </div>
          <button
            type="submit"
            class="btn btnPrimary"
            data-dismiss="modal"
            aria-label="Close"
            (click)="save()"
          >
            Send
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
